/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

import { Badge } from '@hashicorp/mds-react/components'
import sendPosthogEvent from '@web/utils/send-posthog-event'
import s from './blog-subnav-panel.module.css'

type ExploreTopic = {
	slug: string
	title: string
}

export function ExploreTopics({ topics }: { topics: ExploreTopic[] }) {
	return (
		<ul className={s.tags}>
			{topics.map((topic) => {
				const href = `/blog/tags/${topic.slug}`
				return (
					<li key={topic.slug}>
						<a
							href={href}
							className={s.tag}
							onClick={() => {
								sendPosthogEvent('Blog Explore Topics Clicked', {
									tag_slug: topic.slug,
								})
							}}
						>
							<Badge type="outlined" text={topic.title} size="large" />
						</a>
					</li>
				)
			})}
		</ul>
	)
}
